import { ChevronsUpDown, X } from 'lucide-react';

type BaseDropdownProps = {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  selectedCount: number;
};

export function BaseFilterDropdown({
  title,
  isOpen,
  onToggle,
  children,
  selectedCount,
}: BaseDropdownProps) {
  return (
    <div className="relative inline-block">
      <button
        type="button"
        className={`flex w-fit items-center justify-between rounded-[4px] pt-[6px] pb-[6px] pl-[10px] pr-[8px] ${
          selectedCount > 0 || isOpen ? 'bg-[#E5EDFF]' : 'bg-white'
        } cursor-pointer`}
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
      >
        <div className="flex items-center">
          <span className="text-body-sm font-medium text-[#606384]">
            {title}
          </span>
          {selectedCount > 0 && (
            <div className="ml-[4px] flex w-[15px] h-[15px] items-center justify-center rounded-full bg-[#B4C9FF] text-xs text-[#1F202C]">
              {selectedCount}
            </div>
          )}
        </div>
        {isOpen
          ? <X className="ml-[2px] w-[15px] h-[15px] text-[#868aae]" />
          : <ChevronsUpDown className="ml-[2px] w-[15px] h-[15px] text-[#868aae]" />}
      </button>

      {isOpen && (
        <div
          className="absolute z-10 mt-[4px] max-h-[420px] w-fit min-w-[200px] overflow-y-auto rounded-[4px] border border-[#D4D6EC] bg-white"
          role="listbox"
        >
          {children}
        </div>
      )}
    </div>
  );
}
